﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as React from "react";
import type { SelfServiceLoginViewState } from "../Types";
import TextBlock from "~base/Components/Primitives/TextBlock";
import Rubrik from "~base/Components/Primitives/Rubrik";
import type { SoPNLConsilioTheme } from "~jrad/Styling/SoPNLConsilioTheme";
import { createUseStyles } from "react-jss";
import { getSpacing } from "~base/Components/Layout/Spacings";

//-------------------------------------------------------------------------------------
// Props
//-------------------------------------------------------------------------------------

export interface SelfServiceLoginPageAccessDeniedProps {
    isLoading: boolean;
    state: SelfServiceLoginViewState;
}

const useStyles = createUseStyles((theme: SoPNLConsilioTheme) => ({
    container: {
        marginTop: getSpacing("16px"),
    },
}));

//-------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------

const PageAccessDenied: React.FunctionComponent<
    SelfServiceLoginPageAccessDeniedProps
> = ({ isLoading, state }) => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <Rubrik
                rubrikSizeType="Small"
                bottomMargin="Small"
                textCode="SoPNL.UI.SelfServiceLogin.Disabled.Header"
            />
            <TextBlock textCode="SoPNL.UI.SelfServiceLogin.Disabled.Description" />
        </div>
    );
};

export default PageAccessDenied;
